// Elsa ana sayfa etkileşimleri (sections/elsa-home-*.liquid). Birden çok bölüm yüklese de tek kez çalışır.
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__elsaHome) {
  window.__elsaHome = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // Dil metinleri layout/theme.liquid → window.ElsaI18n
  const T = window.ElsaI18n || {};

  /* Scroll ile belirme */
  document.documentElement.classList.add('eh-js');
  const revealIO = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        revealIO.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  const observeReveal = (scope) =>
    scope.querySelectorAll('[data-eh-reveal]:not(.is-in)').forEach((el, i) => {
      el.style.transitionDelay = `${Math.min(i % 4, 3) * 70}ms`;
      revealIO.observe(el);
    });

  /* Sayaç */
  const countIO = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        countIO.unobserve(e.target);
        const end = parseInt(e.target.dataset.ehCount, 10);
        if (!Number.isFinite(end) || reduceMotion) return;
        // Yıl gibi büyük sayılar yakın bir değerden başlar
        const start = end > 1000 ? end - 60 : 0;
        const t0 = performance.now();
        const dur = 1600;
        const tick = (t) => {
          const p = Math.min((t - t0) / dur, 1);
          e.target.textContent = Math.round(start + (end - start) * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    },
    { threshold: 0.6 }
  );

  /* Sekmeler + ok butonları */
  const initTabs = (section) => {
    const tabs = [...section.querySelectorAll('[role="tab"]')];
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = section.querySelector(`#${t.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !on;
      });
      const panel = section.querySelector(`#${tab.getAttribute('aria-controls')}`);
      if (panel) {
        observeReveal(panel);
        updateNav(panel);
      }
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (ev) => {
        if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
        const next = tabs[(i + (ev.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        next.focus();
        select(next);
      });
    });
  };
  const updateNav = (panel) => {
    const rail = panel.querySelector('[data-eh-rail]');
    if (!rail) return;
    const prev = panel.querySelector('[data-eh-prev]');
    const next = panel.querySelector('[data-eh-next]');
    if (prev) prev.disabled = rail.scrollLeft <= 4;
    if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
  };
  const initRails = (scope) =>
    scope.querySelectorAll('.eh-panel').forEach((panel) => {
      const rail = panel.querySelector('[data-eh-rail]');
      if (!rail) return;
      const step = (dir) => rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
      panel.querySelector('[data-eh-prev]')?.addEventListener('click', () => step(-1));
      panel.querySelector('[data-eh-next]')?.addEventListener('click', () => step(1));
      rail.addEventListener('scroll', () => updateNav(panel), { passive: true });
      updateNav(panel);
    });

  /* Fırça bulucu */
  const initFinder = (section) => {
    const steps = section.querySelectorAll('[data-eh-step]');
    const results = section.querySelectorAll('[data-eh-result]');
    const dots = section.querySelectorAll('[data-eh-step-dot]');
    let goal = '';
    const show = (el, n) => {
      [...steps, ...results].forEach((s) => (s.hidden = s !== el));
      dots.forEach((d) => d.classList.toggle('is-on', Number(d.dataset.ehStepDot) <= n));
      observeReveal(el);
      if (n > 1) {
        const top = section.getBoundingClientRect().top;
        if (top < 0) section.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
      el.querySelector('button, a')?.focus({ preventScroll: true });
    };
    const result = (key) => show(section.querySelector(`[data-eh-result="${key}"]`), 3);
    section.querySelectorAll('[data-eh-goal]').forEach((b) =>
      b.addEventListener('click', () => {
        goal = b.dataset.ehGoal;
        if (goal === 'fon') show(section.querySelector('[data-eh-step="2"]'), 2);
        else result(goal);
      })
    );
    section.querySelectorAll('[data-eh-type]').forEach((b) =>
      b.addEventListener('click', () => result(`${goal}-${b.dataset.ehType}`))
    );
    section.querySelectorAll('[data-eh-back], [data-eh-restart]').forEach((b) =>
      b.addEventListener('click', () => show(section.querySelector('[data-eh-step="1"]'), 1))
    );
  };

  /* Sepete ekle: temanın sepet çekmecesi ve sayaç rozeti CartLinesUpdateEvent ile güncellenir */
  let toastEl;
  const toast = (msg) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'eh-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = `<span></span><a href="${root}cart">${T.goToCart || 'Sepete git'}</a>`;
    toastEl.firstChild.textContent = msg;
    requestAnimationFrame(() => toastEl.classList.add('is-on'));
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-on'), 3200);
  };

  const fetchCart = async () => {
    const comp = document.querySelector('cart-items-component');
    if (comp) {
      await customElements.whenDefined('cart-items-component');
      if (typeof comp.fetchCartData === 'function') return comp.fetchCartData();
    }
    return fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  };

  document.addEventListener('click', async (ev) => {
    const btn = ev.target.closest('[data-eh-add]');
    if (!btn) return;
    ev.preventDefault();
    const id = Number(btn.dataset.ehAdd);
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((c) => c.dataset.sectionId)
      .filter(Boolean);
    let deferred;
    try {
      deferred = CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: id, quantity: 1 }],
          promise: deferred.promise,
        })
      );
    } catch (_) {
      deferred = null;
    }

    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Sepete eklenemedi');
      const cart = await fetchCart();
      deferred?.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'elsa-home', itemCount: 1, sections: data.sections, didError: false },
      });
      btn.classList.remove('is-loading');
      btn.classList.add('is-done');
      setTimeout(() => btn.classList.remove('is-done'), 1800);
      if (!document.querySelector('cart-drawer-component[auto-open]')) toast(T.added || 'Ürün sepetinize eklendi ✓');
    } catch (err) {
      btn.classList.remove('is-loading');
      deferred?.resolve({ cart: null, detail: { didError: true, source: 'elsa-home', itemCount: 0 } });
      toast(err.message || T.error || 'Bir sorun oluştu, lütfen tekrar deneyin.');
    }
  });

  /* Slider: kaydırma (scroll-snap) + oklar, noktalar, otomatik geçiş */
  const initSlider = (section) => {
    const track = section.querySelector('[data-eh-slides]');
    const slides = [...track.children];
    const dots = [...section.querySelectorAll('[data-eh-slide-dot]')];
    const rtl = getComputedStyle(track).direction === 'rtl';
    const delay = Number(section.dataset.autoplay) * 1000;
    let index = 0;
    let timer;

    const setCurrent = (i) => {
      index = i;
      slides.forEach((s, n) => {
        const on = n === i;
        s.classList.toggle('is-current', on);
        s.setAttribute('aria-hidden', String(!on));
        s.querySelectorAll('a').forEach((a) => (a.tabIndex = on ? 0 : -1));
      });
      dots.forEach((d, n) => d.setAttribute('aria-current', String(n === i)));
    };
    // Diğer slaytların görselleri ilk görselle bant genişliği paylaşmasın: sonradan yükle
    let hydrated = false;
    const hydrate = () => {
      if (hydrated) return;
      hydrated = true;
      section.querySelectorAll('[data-eh-srcset]').forEach((el) => {
        el.srcset = el.dataset.ehSrcset;
        el.removeAttribute('data-eh-srcset');
      });
      section.querySelectorAll('img[data-eh-src]').forEach((img) => {
        img.src = img.dataset.ehSrc;
        img.removeAttribute('data-eh-src');
      });
    };
    const firstImg = slides[0]?.querySelector('img');
    if (firstImg && !firstImg.complete) firstImg.addEventListener('load', () => setTimeout(hydrate, 1500), { once: true });
    else setTimeout(hydrate, 1500);
    setTimeout(hydrate, Math.max(delay - 1500, 3000));
    ['pointerdown', 'touchstart', 'focusin'].forEach((t) => section.addEventListener(t, hydrate, { once: true, passive: true }));

    const go = (i) => {
      hydrate();
      const n = (i + slides.length) % slides.length;
      track.scrollTo({ left: (rtl ? -1 : 1) * slides[n].offsetWidth * n, behavior: reduceMotion ? 'auto' : 'smooth' });
      setCurrent(n);
      restart();
    };
    const restart = () => {
      clearTimeout(timer);
      if (!delay || reduceMotion || slides.length < 2) return;
      section.style.setProperty('--eh-dur', `${delay}ms`);
      section.setAttribute('data-playing', '');
      // animasyonu yeniden başlat
      dots.forEach((d) => d.querySelector('i')?.replaceWith(d.querySelector('i').cloneNode()));
      timer = setTimeout(() => go(index + 1), delay);
    };
    const stop = () => {
      clearTimeout(timer);
      section.removeAttribute('data-playing');
    };

    let scrollT;
    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollT);
        scrollT = setTimeout(() => {
          const n = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
          if (n !== index) {
            setCurrent(n);
            restart();
          }
        }, 120);
      },
      { passive: true }
    );
    section.querySelector('[data-eh-slide-prev]')?.addEventListener('click', () => go(index - 1));
    section.querySelector('[data-eh-slide-next]')?.addEventListener('click', () => go(index + 1));
    dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.ehSlideDot))));
    section.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') go(index + (rtl ? -1 : 1));
      if (e.key === 'ArrowLeft') go(index - (rtl ? -1 : 1));
    });
    section.addEventListener('pointerenter', stop);
    section.addEventListener('pointerleave', restart);
    section.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : restart()));

    setCurrent(0);
    restart();
  };

  /* Alışverişli UGC videoları (elsa-home-social): görünen kart sessiz döngüde 480p, dokununca 720p pencere + ürün */
  const saveData = (() => {
    try {
      return Boolean(navigator.connection?.saveData);
    } catch {
      return false;
    }
  })();
  const initUgc = (section) => {
    if (section.dataset.ehUgcReady) return;
    section.dataset.ehUgcReady = '1';
    const cards = [...section.querySelectorAll('.eh-ugc__card')];
    const dlg = section.querySelector('[data-eh-ugc-dlg]');
    if (!cards.length || !dlg) return;
    const player = dlg.querySelector('video');
    const bar = dlg.querySelector('.eh-ugc-dlg__bar');

    // Kapaklar açılışta ilk görselle bant genişliği paylaşmasın: bölüme yaklaşınca yükle
    const showPosters = () =>
      cards.forEach((c) => {
        const v = c.querySelector('video');
        if (v.dataset.poster) v.poster = v.dataset.poster;
      });
    if ('IntersectionObserver' in window) {
      const posterIO = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          posterIO.disconnect();
          showPosters();
        },
        { rootMargin: '1500px 0px' }
      );
      posterIO.observe(section);
    } else showPosters();

    if (!reduceMotion && !saveData && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) =>
          entries.forEach((e) => {
            const v = e.target.querySelector('video');
            if (e.isIntersecting && e.intersectionRatio >= 0.6 && !dlg.open) {
              if (!v.src) v.src = v.dataset.src;
              v.play().catch(() => {});
              e.target.classList.add('is-playing');
            } else {
              v.pause();
              e.target.classList.remove('is-playing');
            }
          }),
        { threshold: [0, 0.6] }
      );
      cards.forEach((c) => io.observe(c));
    }

    const close = () => dlg.open && dlg.close();
    cards.forEach((card) =>
      card.addEventListener('click', () => {
        cards.forEach((c) => c.querySelector('video').pause());
        const prod = card.parentElement.querySelector('.eh-ugc__prod');
        bar.hidden = !prod;
        bar.replaceChildren();
        if (prod) {
          const link = prod.cloneNode(true);
          link.className = 'eh-ugc-dlg__prod';
          const btn = document.createElement('a');
          btn.className = 'eh-btn eh-btn--dark';
          btn.href = prod.href;
          btn.textContent = dlg.dataset.tView;
          bar.append(link, btn);
        }
        player.poster = card.querySelector('video').dataset.poster || '';
        player.src = card.dataset.ehUgcHd;
        dlg.showModal();
        player.play().catch(() => {});
      })
    );
    dlg.querySelector('[data-eh-ugc-close]').addEventListener('click', close);
    dlg.addEventListener('click', (e) => e.target === dlg && close());
    dlg.addEventListener('close', () => {
      player.pause();
      player.removeAttribute('src');
      player.load();
    });
  };

  /* Alt bölüm görselleri (data-eh-defer-src): ilk görsel yüklendikten sonra, ilk dokunuş/kaydırmada ya da en geç 3,5 sn'de */
  let deferDone = false;
  const showDeferred = (scope) =>
    scope.querySelectorAll('img[data-eh-defer-src]').forEach((img) => {
      if (img.dataset.ehDeferSrcset) img.srcset = img.dataset.ehDeferSrcset;
      img.src = img.dataset.ehDeferSrc;
      img.removeAttribute('data-eh-defer-srcset');
      img.removeAttribute('data-eh-defer-src');
    });
  const loadDeferred = () => {
    if (deferDone) return;
    deferDone = true;
    showDeferred(document);
  };
  const heroImg = document.querySelector('img[fetchpriority="high"]');
  if (heroImg && !heroImg.complete) {
    heroImg.addEventListener('load', () => setTimeout(loadDeferred, 300), { once: true });
    heroImg.addEventListener('error', loadDeferred, { once: true });
  } else setTimeout(loadDeferred, 300);
  setTimeout(loadDeferred, 3500);
  ['scroll', 'touchstart', 'pointerdown', 'keydown'].forEach((t) =>
    window.addEventListener(t, loadDeferred, { once: true, passive: true })
  );

  /* Kart hover görseli: ilk hover'da yükle */
  document.addEventListener(
    'pointerover',
    (ev) => {
      if (ev.pointerType !== 'mouse') return;
      const alt = ev.target.closest?.('.eh-card')?.querySelector('img[data-eh-srcset]');
      if (!alt) return;
      alt.srcset = alt.dataset.ehSrcset;
      alt.removeAttribute('data-eh-srcset');
    },
    { passive: true }
  );

  const init = (scope = document) => {
    observeReveal(scope);
    scope.querySelectorAll('[data-eh-count]').forEach((el) => countIO.observe(el));
    scope.querySelectorAll('[data-eh-tabs]').forEach(initTabs);
    initRails(scope);
    scope.querySelectorAll('[data-eh-finder]').forEach(initFinder);
    scope.querySelectorAll('[data-eh-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-eh-ugc]').forEach(initUgc);
  };
  init();

  // Tema düzenleyicide bölüm yeniden yüklendiğinde
  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
    if (deferDone) showDeferred(e.target);
  });
}
